// extracted by mini-css-extract-plugin
export default {"main-div":"VictimsList_main-div__9-a+k","submit-btn":"VictimsList_submit-btn__IplZ5"};